module.exports = __webpack_public_path__ + "img/shanchu.19b49c40.png";